<div class="modal-header">
    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="cancel()">
        <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">Add Aircraft</h4>
</div>
<div class="modal-body">
    <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
    <div class="spinner" *ngIf="true != dataLoaded"></div>
    <form [formGroup]="aircraftForm" *ngIf="true == dataLoaded" autocomplete="off">
        <fieldset>
            <div class="row">
                <div class="col-sm-3 mvd_form-group">
                    <label class="required" title="* Required" for="faaNumber">FAA Number</label>
                    <input maxlength="5" formControlName="faaNumber" id="faaNumber" class="mvd_form-control" type="text" oninput="this.value = this.value.toUpperCase()"/>
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label class="required" title="* Required" for="serialNumber">Serial Number</label>
                    <input maxlength="20" formControlName="serialNumber" id="serialNumber" class="mvd_form-control" type="text" oninput="this.value = this.value.toUpperCase()"/>
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label class="required" title="* Required" for="aircraftTypeId">Aircraft Type</label>
                    <select class="mvd_form-control" formControlName="aircraftTypeId">
                        <option value="0">- Select -</option>
                        <option *ngFor="let aircraftType of aircraftTypes" [value]="aircraftType.value">{{ aircraftType.text }}</option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-3 mvd_form-group">
                    <label class="required" title="* Required" for="year">Year</label>
                    <input id="year" maxlength="4" formControlName="year" class="mvd_form-control" type="text"/>
                    <control-validation-messages control="year"></control-validation-messages>
                </div>

                <div class="col-sm-3 mvd_form-group">
                    <label class="required" title="* Required" for="manufacturer">
                        Manufacturer
                        <a class="icon--add" *ngIf="!aircraftForm.controls.manufacturer.value" href="javascript:void(0)" title="Add Manufacturer" (click)="addNewManufacturer();"></a>
                    </label>
                    <p-autoComplete id="manufacturer" formControlName="manufacturer" (onSelect)="selectMake($event)" [suggestions]="makeResults" (completeMethod)="searchMakes($event)"></p-autoComplete>
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <label class="required" title="* Required" for="model">
                        Model
                        <a class="icon--add" href="javascript:void(0)" title="Add Model" (click)="addNewModel();"></a>
                    </label>
                    <select class="mvd_form-control" formControlName="model">
                        <option value="0">- Select -</option>
                        <option *ngFor="let model of aircraftMakeModels" [value]="model.value">{{ model.text }}</option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4 mvd_form-group">
                    <label class="required" title="* Required" for="airport">Base Airport</label>
                    <p-autoComplete id="airport" formControlName="airport" type="text" (onSelect)="selectAirport($event)" [suggestions]="airportResults" (completeMethod)="searchAirports($event)"></p-autoComplete>
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label class="required" title="* Required" for="county">County</label>
                    <div id="county" class="mvd_form-control">{{ airportCounty }}</div>
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label class="required" title="* Required" for="city">City</label>
                    <div id="city" class="mvd_form-control">{{ airportCity }}</div>
                </div>                
            </div>
        </fieldset>
    </form>
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" type="button" (click)="cancel()">Cancel</button>
        <button class="btn--primary" type="submit" [disabled]="true != aircraftForm.valid" (click)="save()">Add</button> <!--ForceCodeChange-->
    </div>
</div>